var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_c('push-notification'),_c('notifications'),_c('UpdateMessageBox'),_c('DepartmentAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }